/**
 * Registre statique des logos de certification (#2116). Map clé interne →
 * asset dans apps/catalog/public/. Dimensions intrinsèques issues de la
 * maquette Figma ; l'affichage est normalisé à une hauteur fixe (cf. DmcPage).
 */
import type { CertificationLogoKey } from '@/app/api/lib/dmcs/dmc.types';

type CertificationLogoAsset = {
    src: string;
    alt: string;
    /** Dimensions intrinsèques (ratio) requises par next/image. */
    width: number;
    height: number;
    /** Bornes d'affichage en px (preserve le ratio via objectFit contain). */
    displayMaxWidth: number;
    displayMaxHeight: number;
    /**
     * Largeur d'affichage explicite en px. Optionnel : utile pour AGRANDIR un
     * logo dont la taille intrinsèque est plus petite que le rendu voulu
     * (ex. Travelife Partner, 239px de large). `displayMaxWidth`/`Height` ne font que
     * plafonner — ils n'agrandissent jamais au-delà de la taille naturelle.
     */
    displayWidth?: number;
};

export const CERTIFICATION_LOGOS: Record<CertificationLogoKey, CertificationLogoAsset> = {
    travelifePartner: {
        src: '/travelife-logo.png',
        alt: 'Travelife Partner',
        width: 239,
        height: 93,
        displayMaxWidth: 400,
        displayMaxHeight: 160,
        displayWidth: 220,
    },
    travelifeCertified: {
        src: '/travelife-certified-logo.png',
        alt: 'Travelife Certified',
        width: 675,
        height: 263,
        displayMaxWidth: 400,
        displayMaxHeight: 160,
        displayWidth: 260,
    },
    bcorp: {
        src: '/bcorp-logo.svg',
        alt: 'B Corp',
        width: 126,
        height: 186,
        displayMaxWidth: 140,
        displayMaxHeight: 160,
    },
    qualiteTourisme: {
        src: '/tourism-quality.png',
        alt: 'Qualité Tourisme',
        width: 264,
        height: 127,
        displayMaxWidth: 320,
        displayMaxHeight: 200,
    },
};
